import { useState } from "react";

import RuleSettings, { directions, randomDirection } from "./RuleSettings";

const orientations = {
    R: "Right",
    D: "Down",
    L: "Left",
    U: "Up",
};

function AntSettings({ settings, setSettings, antIndex }) {
    const [newRuleDirection, setNewRuleDirection] = useState('R');

    const ant = settings.ants[antIndex];

    return (
        <div className="accordion-item">
            <h2 className="accordion-header">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={"#ant_" + antIndex}>
                    {ant.rules.length > 0 ? ant.rules.map(rule => rule.direction).join("") : "Empty"}
                </button>
            </h2>
            <div id={"ant_" + antIndex} className="accordion-collapse collapse" data-bs-parent="#ants">
                <div className="accordion-body">
                    <div className="mb-3">
                        <button
                            type="button" className="btn btn-danger"
                            onClick={() => setSettings({
                                ...settings,
                                reset: true,
                                ants: settings.ants.filter((_, _antIndex) => _antIndex !== antIndex),
                            })}
                        >
                            Remove
                        </button>
                    </div>
                    <div className="mb-3 row">
                        <label htmlFor={"ant_" + antIndex + "_x"} className="col-4 col-form-label">X</label>
                        <div className="col-8">
                            <div className="input-group">
                                <input
                                    type="number" id={"ant_" + antIndex + "_x"} className="form-control" min="0" max="100"
                                    value={ant.startX}
                                    onChange={e => {
                                        const value = e.target.value ? parseInt(e.target.value, 10) : 0;
                                        if (value >= 0 && value <= 100) {
                                            setSettings({
                                                ...settings,
                                                reset: true,
                                                ants: settings.ants.map((_ant, _antIndex) => {
                                                    if (_antIndex === antIndex) {
                                                        return {
                                                            ..._ant,
                                                            startX: value,
                                                        };
                                                    }
                                                    return _ant;
                                                }),
                                            });
                                        }
                                    }}
                                />
                                <span className="input-group-text">%</span>
                            </div>
                        </div>
                    </div>
                    <div className="mb-3 row">
                        <label htmlFor={"ant_" + antIndex + "_y"} className="col-4 col-form-label">Y</label>
                        <div className="col-8">
                            <div className="input-group">
                                <input
                                    type="number" id={"ant_" + antIndex + "_y"} className="form-control" min="0" max="100"
                                    value={ant.startY}
                                    onChange={e => {
                                        const value = e.target.value ? parseInt(e.target.value, 10) : 0;
                                        if (value >= 0 && value <= 100) {
                                            setSettings({
                                                ...settings,
                                                reset: true,
                                                ants: settings.ants.map((_ant, _antIndex) => {
                                                    if (_antIndex === antIndex) {
                                                        return {
                                                            ..._ant,
                                                            startY: value,
                                                        };
                                                    }
                                                    return _ant;
                                                }),
                                            });
                                        }
                                    }}
                                />
                                <span className="input-group-text">%</span>
                            </div>
                        </div>
                    </div>
                    <div className="mb-3 row">
                        <label htmlFor={"ant_" + antIndex + "_orientation"} className="col-4 col-form-label">Orientation</label>
                        <div className="col-8">
                            <select
                                className="form-select" id={"ant_" + antIndex + "_orientation"}
                                value={ant.startOrientation}
                                onChange={e => setSettings({
                                    ...settings,
                                    reset: true,
                                    ants: settings.ants.map((_ant, _antIndex) => {
                                        if (_antIndex === antIndex) {
                                            return {
                                                ..._ant,
                                                startOrientation: e.target.value,
                                            };
                                        }
                                        return _ant;
                                    }),
                                })}
                            >
                                {Object.keys(orientations).map(orientation => (
                                    <option key={orientation} value={orientation}>
                                        {orientations[orientation]}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="mb-3">
                        <label htmlFor={"ant_" + antIndex + "_rules"} className="form-label">Rules</label>
                        <div className="input-group mb-3">
                            <button
                                type="button" className="btn btn-secondary"
                                onClick={() => {
                                    setNewRuleDirection(randomDirection());
                                    document.getElementById("ant_" + antIndex + "_new_rule_direction").focus();
                                }}
                            ><i className="bi bi-dice-3-fill"></i></button>
                            <select
                                className="form-select" id={"ant_" + antIndex + "_new_rule_direction"}
                                value={newRuleDirection}
                                onChange={e => setNewRuleDirection(e.target.value)}
                            >
                                {Object.keys(directions).map(direction => (
                                    <option key={direction} value={direction}>
                                        {directions[direction]}
                                    </option>
                                ))}
                            </select>
                            <button
                                type="button" className="btn btn-primary"
                                onClick={() => {
                                    setSettings({
                                        ...settings,
                                        reset: true,
                                        ants: settings.ants.map((_ant, _antIndex) => {
                                            if (_antIndex === antIndex) {
                                                return {
                                                    ..._ant,
                                                    rules: [
                                                        ..._ant.rules,
                                                        {
                                                            direction: newRuleDirection,
                                                            color: Math.floor(Math.random() * 16),
                                                        },
                                                    ],
                                                };
                                            }
                                            return _ant;
                                        }),
                                    });
                                    setNewRuleDirection("");
                                }}
                            >
                                Add
                            </button>
                        </div>
                        <div className="accordion" id={"ant_" + antIndex + "_rules"}>
                            {ant.rules.map((rule, ruleIndex) => (
                                <RuleSettings key={ruleIndex} settings={settings} setSettings={setSettings} antIndex={antIndex} ruleIndex={ruleIndex} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export function randomOrientation() {
    return Object.keys(orientations)[Math.floor(Math.random() * Object.keys(orientations).length)];
}

export default AntSettings;
